import React from 'react';
import Typography from '@digital-hig/mui/dist/Typography';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DOMPurify from 'isomorphic-dompurify';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
import Skeleton from 'react-loading-skeleton';

const Overview = ({
  showLoader, data, sectionRef, sectionId, title,
}) => (
  <RootElement ref={sectionRef} data-id={sectionId}>
    {showLoader ? <Skeleton height={72} />
      : (
        <Grid lg={8} sm={12}>
          <Typography component="h2" variant="headline-medium">{title}</Typography>
          <Typography dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data) }} />
        </Grid>
      )}
  </RootElement>
);

const RootElement = styled.div`
    margin-bottom: 65px;
`;

Overview.propTypes = {
  showLoader: PropTypes.bool,
  sectionRef: PropTypes.shape({}).isRequired,
  sectionId: PropTypes.string.isRequired,
  data: PropTypes.string,
  title: PropTypes.string,
};

Overview.defaultProps = {
  showLoader: false,
  data: '',
  title: 'Course overview',
};

export default React.memo(Overview);
